import {
  VIEWING_ACTION_ARCHIVE,
  VIEWING_ACTION_ARCHIVE_MASS,
} from '../../RentalPortalViewings.constants'

export const VIEWING_SINGLE_ACTION_BY_MASS_ACTION = {
  [VIEWING_ACTION_ARCHIVE_MASS]: VIEWING_ACTION_ARCHIVE,
}
